package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_07_28_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-07-28")
@Composable
public fun Log_2023_07_28(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Traps and Hobgoblins",
        ogTitle = "Traps and Hobgoblins",
        date = LocalDate(2_023, 7, 28),
        ogDescription = "After resting, the party navigates a heavily trapped tunnel and engages a vanguard of hostile Hobgoblins.",
        ogImage = "ai/2023-07-28.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
        Log_2023_07_28_Day_1()
    }
}
